module.exports = __webpack_public_path__ + "img/de-flag.fe4467c4.png";